import { RecommendedJobsBlockData } from 'api/cms';
import { BlockMapping } from 'cms/blocks/BlockMapping';

import { RecommendedJobsBlock } from './RecommendedJobsBlock';

export const RecommendedJobsBlockMapping: BlockMapping<RecommendedJobsBlockData> =
  {
    invariant: [],
    width: ({ layout }) => (layout === 'SLIM' ? 'NARROW' : 'GRID'),
    Component: RecommendedJobsBlock,

    AmpComponent: RecommendedJobsBlock,
  };
